import React from 'react';
import Icon from '../../../components/AppIcon';

const RealtimeMonitor = ({ data, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-card rounded-lg p-6 border border-border card-elevated-1">
        <div className="animate-pulse space-y-4">
          <div className="h-6 bg-muted rounded w-1/2"></div>
          <div className="space-y-3">
            {[1, 2, 3]?.map((i) => (
              <div key={i} className="h-16 bg-muted rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const statusConfig = {
    active: { color: 'text-success', bg: 'bg-success/10', icon: 'Activity' },
    warning: { color: 'text-warning', bg: 'bg-warning/10', icon: 'AlertTriangle' },
    critical: { color: 'text-error', bg: 'bg-error/10', icon: 'AlertCircle' }
  };

  return (
    <div className="bg-card rounded-lg border border-border card-elevated-1">
      <div className="p-6 border-b border-border flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-success animate-pulse"></div>
          <h3 className="text-lg font-semibold text-foreground">Surveillance en temps réel</h3>
        </div>
        <span className="text-xs text-muted-foreground">
          Mis à jour il y a {data?.lastUpdate}
        </span>
      </div>
      <div className="p-6 space-y-4">
        {data?.metrics?.map((metric) => {
          const config = statusConfig?.[metric?.status];
          return (
            <div 
              key={metric?.id}
              className="flex items-center justify-between p-4 rounded-lg border border-border hover:shadow-md transition-all duration-200"
            >
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-lg ${config?.bg} flex items-center justify-center`}>
                  <Icon name={config?.icon} size={24} className={config?.color} />
                </div>
                <div>
                  <p className="font-medium text-foreground">{metric?.label}</p>
                  <p className="text-sm text-muted-foreground">{metric?.description}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-2xl font-semibold text-foreground">{metric?.value}</p>
                {metric?.change && (
                  <p className={`text-xs font-medium ${
                    metric?.changeType === 'positive' ? 'text-success' : 'text-error'
                  }`}>
                    {metric?.changeType === 'positive' ? '+' : ''}{metric?.change}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className="p-4 border-t border-border bg-muted/30">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Prochaine actualisation dans</span>
          <span className="font-medium text-foreground">30 secondes</span>
        </div>
      </div>
    </div>
  );
};

export default RealtimeMonitor;